// extracted by mini-css-extract-plugin
export default {"autoComplete":"PS-z","error":"QS-z","disabled":"RS-z"};